export function dateOrStringToDate(date: Date): Date {
	if (date instanceof Date) {
		return date;
	} else {
		return new Date(date);
	}
}
